import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbFullPageFlow } from '@celebration/design-system/dist/lib/full-page-flow';

export default createComponent({
    react: React,
    elementClass: ClbFullPageFlow,
    tagName: ClbFullPageFlow.tagName,
    events: ClbFullPageFlow.events,
});
